import { Box, Button, CircularProgress, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { useRecords } from "../../../../api/useRecords";
import { ScheduleActionFormData } from "./types";

type ServicesUpdaterProps = {
    control: Control<ScheduleActionFormData>;
    isUpdatingServices: boolean;
    onUpdateServices: () => void;
    onRemoveServices: () => void;
    onCancel: () => void;
};

export const ServicesUpdater = ({ control, isUpdatingServices, onUpdateServices, onRemoveServices, onCancel }: ServicesUpdaterProps) => {
    const selectedServices = useWatch({ control, name: "selectedServices" });

    const { data: services, status } = useRecords("services", "id,name,max_duration", {
        staleTime: Infinity,
        extraOptions: { sort: "sort_order", filter: { sort_order: { _nnull: true } } },
    });

    const isLoading = status === "loading";

    return (
        <Box p={2}>
            <Controller
                name="selectedServices"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="services-select-label">Serviços</InputLabel>
                        <Select
                            labelId="services-select-label"
                            label="Serviços"
                            multiple
                            value={field.value || []}
                            name={field.name}
                            onBlur={field.onBlur}
                            onChange={(e) => {
                                const value = e.target.value as Array<number>;
                                field.onChange(value);
                            }}
                            inputRef={field.ref}
                        >
                            {services?.items?.map((service: any) => (
                                <MenuItem key={service.id} value={service.id}>
                                    {service.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            />
            <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={onUpdateServices}
                disabled={isLoading || isUpdatingServices || !selectedServices || selectedServices.length === 0}
                sx={{ mb: 1 }}
            >
                {isUpdatingServices ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Atualizar Serviços
            </Button>
            <Button
                fullWidth
                variant="contained"
                color="error"
                size="small"
                onClick={onRemoveServices}
                disabled={isLoading || isUpdatingServices}
                sx={{ mb: 1 }}
            >
                {isUpdatingServices ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Remover Serviços
            </Button>
            <Button fullWidth color="secondary" size="small" onClick={onCancel}>
                Cancelar
            </Button>
        </Box>
    );
};
